import {Select} from 'antd';
import {FormInstance} from 'antd/es/form';
import React, {useEffect, useState} from 'react';

import {IGenerateOptionsRulesProps} from 'entities/metadata';
import {TEntity} from 'modules/data';
import {combineString} from 'shared/utils/combine-string';

interface IUseGenerateOptionsArgs {
    options?: TEntity[];
    generateOptionsRules?: IGenerateOptionsRulesProps;
    form?: FormInstance;
}

export const useGenerateOptions = ({
    options,
    generateOptionsRules,
    form,
}: IUseGenerateOptionsArgs) => {
    const [isGenerating, setGenerating] = useState<boolean>(!options?.length);
    const [generatedOptions, setGeneratedOptions] = useState<TEntity[] | undefined>(undefined);

    const dynamicToValue = generateOptionsRules?.dynamicTo
        && combineString(generateOptionsRules.dynamicTo, form?.getFieldsValue());

    useEffect(() => {
        if (!generateOptionsRules) {
            return;
        }
        const {
            from, to, dynamicTo,
        } = generateOptionsRules;
        if (from && to) {
            setGeneratedOptions(generateOptions(from, to));
            setGenerating(false);
        }
        if (from && dynamicTo) {
            const newOptions = generateOptions(1, Number(dynamicToValue));
            if (newOptions.length) {
                setGeneratedOptions(newOptions);
            }
            setGenerating(false);
        }
    }, [form, dynamicToValue]);

    function generateOptions(from: number, to: number): any[] {
        const genOptions = [];
        for (let i = from; i <= to; i += 1) {
            genOptions?.push(
                <Select.Option
                    value={i}
                    key={i}
                    className="select-field__option"
                >
                    {i}
                </Select.Option>,
            );
        }
        return genOptions;
    }

    return {
        isGenerating,
        generatedOptions,
    };
};
